/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useState} from 'react'
import {chooseUserFranchise, getFranchises, loginKpi, loginAdmin} from './core/_request'
import Swal from 'sweetalert2'
import {KTIcon} from '../../_metronic/helpers'
import {useNavigate} from 'react-router-dom'
import {Franchise} from '../franchise/list/core/_models'
import {useAuth} from '../../app/modules/auth'
import {PageOverlayer} from '../../components/PageOverlayer'
import useAuthorization from '../../hooks/useAuthorization'

export const AuthCreatePage = () => {
  const [loadingPage, setLoadingPage] = useState(false)
  const navigate = useNavigate()
  const [franchises, setFranchises] = useState([])
  const {setCurrentFranchise} = useAuth()
  const isAuthorizedToShow = useAuthorization('kpi.view')
  const isAuthorizedToShowAdmin = useAuthorization('admin.access')

  useEffect(() => {
    async function init() {
      try {
        setLoadingPage(true)
        const franchises = await getFranchises()
        setFranchises(franchises)
      } catch (error: any) {
        await Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error?.response?.data?.message,
          timer: 2000,
        })
      } finally {
        setLoadingPage(false)
      }
    }
    init()
  }, [])

  const saveChoose = async (cnpj) => {
    await Swal.fire({
      title: 'Deseja escolher essa franquia?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'btn btn-danger', // Classe personalizada para o botão de confirmação
        cancelButton: 'btn btn-secondary', // Classe personalizada para o botão de cancelamento (opcional)
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoadingPage(true)
        try {
          if (cnpj === '000000000000000') {
            await loginKpi()
            setCurrentFranchise(undefined)
            navigate(`/kpi/dashboard`)
            await Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Logado com sucesso',
              showConfirmButton: false,
              timer: 1500,
            })
          } else if (cnpj === '111111111111111') {
            await loginAdmin()
            setCurrentFranchise(undefined)
            navigate(`/admin/cielo-merchants`)
            await Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Logado com sucesso',
              showConfirmButton: false,
              timer: 1500,
            })
          } else {
            const data = await chooseUserFranchise({franchise: cnpj})
            setCurrentFranchise(data)
            navigate(`/auth`)
            await Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Logado com sucesso',
              showConfirmButton: false,
              timer: 1500,
            })
          }
        } catch (error: any) {
          if (error.response.status === 422) {
            let errorText = ''
            for (let key in error.response.data.errors) {
              errorText += '<li>' + error.response.data.errors[key][0] + '</li>'
            }
            await Swal.fire({
              icon: 'error',
              title: 'Ops! Revise seu formulário e tente novamente!',
              html: errorText,
            })
          } else {
            await Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: error.response.data.message,
              timer: 2000,
            })
          }
        } finally {
          setLoadingPage(false)
        }
      }
    })
  }

  return (
    <>
      {loadingPage ? (
        <PageOverlayer />
      ) : (
        <div className='d-flex flex-column flex-root'>
          <div className='d-flex flex-column flex-center flex-column-fluid'>
            <div className='d-flex flex-column flex-center text-center p-10'>
              <div className='card card-flush  w-lg-1000px py-5'>
                <div className='card-body py-2 lg-20 h-100'>
                  <div className='w-100'>
                    <div className='pb-10 pb-lg-15'>
                      <h2 className='fw-bolder d-flex align-items-center text-dark justify-content-center'>
                        Escolha a Franquia desejada
                        <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          data-bs-toggle='tooltip'
                          title='Billing is issued based on your selected account type'
                        ></i>
                      </h2>
                    </div>
                    <div className='container'>
                      <div className='row'>
                        {isAuthorizedToShow && (
                          <div className='col-md-6 col-sm-12 mt-3'>
                            <button
                              type='button'
                              className='btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center w-100'
                              value={'000000000000000'}
                              onClick={() => {
                                saveChoose('000000000000000')
                              }}
                            >
                              <KTIcon iconName='briefcase' className='fs-3x me-5' />
                              <span className='d-block fw-bold text-start'>
                                <span className='text-dark fw-bolder d-block fs-4 mb-2'>KPI</span>
                                <span className='text-gray-400 fw-bold fs-6'>
                                  000.000.000/0000-00
                                </span>
                              </span>
                            </button>
                          </div>
                        )}
                        {isAuthorizedToShowAdmin && (
                          <div className='col-md-6 col-sm-12 mt-3'>
                            <button
                              type='button'
                              className='btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center w-100'
                              value={'111111111111111'}
                              onClick={() => {
                                saveChoose('111111111111111')
                              }}
                            >
                              <KTIcon iconName='shield-tick' className='fs-3x me-5' />
                              <span className='d-block fw-bold text-start'>
                                <span className='text-dark fw-bolder d-block fs-4 mb-2'>Admin</span>
                                <span className='text-gray-400 fw-bold fs-6'>
                                  000.000.000/0000-00
                                </span>
                              </span>
                            </button>
                          </div>
                        )}
                        {franchises.map((franchise: Franchise, index) => (
                          <div key={index} className='col-md-6 col-sm-12 mt-3'>
                            <button
                              type='button'
                              className='btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center w-100'
                              value={franchise.person?.juridicalPerson?.cnpjWithoutMask}
                              onClick={() => {
                                const cnpj = franchise.person?.juridicalPerson?.cnpjWithoutMask
                                saveChoose(cnpj)
                              }}
                            >
                              <KTIcon iconName='briefcase' className='fs-3x me-5' />
                              <span className='d-block fw-bold text-start'>
                                <span className='text-dark fw-bolder d-block fs-4 mb-2'>
                                  {franchise.name}
                                </span>
                                <span className='text-gray-400 fw-bold fs-6'>
                                  {franchise.person?.juridicalPerson?.cnpj}
                                </span>
                              </span>
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default AuthCreatePage
